<template>
  <PageLayout class="quotations-page">
    <PageTitle class="page-title">
      <div class="">{{ quotationRequestTitle }}</div>
      <div v-if="quotationRequestStatus" :class="['status', `status-${quotationRequestStatus}`]">
        <span>{{ quotationRequestStatusName }}</span>
      </div>
    </PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    <QuotationInfoBlock @change-title-data="changeTitleData"/>
  </PageLayout>
</template>

<script>

import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";
import QuotationInfoBlock from '@/views/quotations/components/QuotationInfoBlock.vue'

export default {
  data() {
    return {
      quotationRequestTitle: 'Запит ',
      quotationRequestStatus: null,
      quotationRequestStatusName: null,
      breadcrumbs: [
        {
          title: 'Центр котирування',
        },
        {
          title: 'Деталі запиту',
        },
      ],
    }
  },
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, PageTitle, Breadcrumbs, QuotationInfoBlock },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
    changeTitleData(quotationRequestId, quotationRequestData) {
      if (quotationRequestId) {
        const titleChanged = 'Запит ' + quotationRequestId;
        this.quotationRequestTitle = titleChanged;
        this.breadcrumbs[1].title = titleChanged;
        this.quotationRequestStatus =  quotationRequestData.status;
        this.quotationRequestStatusName = quotationRequestData.statusName;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.page-title {
  display: flex;
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
  border: 1px solid #dde2e5 !important;
  border-radius: 3px !important;

  &:hover {
    border-color: #ffad3d !important;
  }
}

::v-deep .multiselect__input {
  border: none !important;
}

@media (max-width: 1220px) and (min-width: 992px) {
  ::v-deep .list-propositions .tabs-block {
    max-width: none;
    width: 100%;
  }
}

.status {
  margin-left: 8px;
  margin-top: 8px;
  width: fit-content;
  max-width: 220px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: baseline;
  border-radius: 30px;
  background: red;
  padding-right: 10px;
  padding-left: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;

  span {
    height: 21px;
    font-family: Circe;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #fff;
  }

  &.status-0 {
    background: #34393D;
  }

  &.status-1 {
    background: #2A7DA6;
  }

  &.status-2 {
    background: #D2C646;
  }

  &.status-3 {
    background: #C9408C;
  }

  &.status-4 {
    background: #D08A2F;

  }

  &.status-5 {
    background: #891AF2;
  }

  &.status-6 {
    background: red;
  }
}

</style>

